import React from "react";
import { Fish } from "lucide-react";
import BrandLogo from "./BrandLogo";
import { NAV_LINKS } from "../mock/mock";
import { SOCIAL_LINKS } from "./SocialIcons";

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-slate-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-10 pb-12 border-b border-white/10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <BrandLogo variant="white" className="w-9 h-9" />
              <span className="font-display font-800 text-xl">Sharkbowl Games</span>
            </div>
            <p className="text-white/50 max-w-xs">
              A London based games studio crafting bold, joyful video games.
            </p>
          </div>
          <div>
            <h4 className="font-display font-700 mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => scrollTo(l.href)}
                    className="text-white/50 hover:text-cyan-400 transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display font-700 mb-4">Follow us</h4>
            <div className="flex gap-3">
              {SOCIAL_LINKS.map(({ name, Icon, href }) => (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={name}
                  className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center hover:bg-teal-600 transition-colors"
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-white/40 text-sm">
          <p>© {new Date().getFullYear()} Sharkbowl Games. All rights reserved.</p>
          <p className="flex items-center gap-1.5">Made with <Fish className="w-4 h-4 text-cyan-400" /> in London</p>
        </div>
      </div>
    </footer>
  );
}